import React from 'react'
import './H1.scss'

const H1 = ({text}) => {
  return (
    <h1>{text}</h1>
  )
}

export default H1